import classNames from 'classnames';
import DOMPurify from 'dompurify';

import { LIVE_BANNER_PURIFY_CONFIG } from '../../constants/liveBannerSanitize';
import CloseIconBold from '../SVGIcons/CloseIconBold';
import CrownLogoBlackWhite from '../SVGIcons/CrownLogoBlackWhite';

import styles from './LiveBanner.module.scss';

const LiveBannerLogo = (props: { showLogo: boolean }) => {
  return (
    <p className={classNames(styles.sideSlot)}>
      <CrownLogoBlackWhite
        aria-hidden={!props.showLogo}
        className={classNames(styles.bannerLogo, !props.showLogo && styles.hidden)}
      />
    </p>
  );
};

const LiveBannerText = (props: { bannerMessage: string }) => {
  const sanitized = DOMPurify.sanitize(props.bannerMessage, LIVE_BANNER_PURIFY_CONFIG);
  return <p className={classNames(styles.textContainer)} dangerouslySetInnerHTML={{ __html: sanitized }}></p>;
};

const LiveBannerCloseButton = (props: { onCloseClick?: () => void }) => {
  return (
    <p className={classNames(styles.sideSlot, typeof props.onCloseClick !== 'function' && styles.hidden)}>
      <button type="button" onClick={props.onCloseClick}>
        <CloseIconBold />
      </button>
    </p>
  );
};

export const LiveBannerDisplay = ({
  onCloseClick,
  showLogo = false,
  bannerMessage,
}: {
  onCloseClick?: () => void;
  showLogo?: boolean;
  bannerMessage: string;
}) => {
  return (
    <div className={classNames(styles.bannerContainer)}>
      <LiveBannerLogo showLogo={showLogo} />
      <LiveBannerText bannerMessage={bannerMessage} />
      <LiveBannerCloseButton onCloseClick={onCloseClick} />
    </div>
  );
};
